module.exports = __webpack_public_path__ + "img/check_20_checked.14d21461.svg";